export default {
  path: '/marketing',
  name: 'marketing',
  meta: { title: '营销作战图' },
  children: [
    {
      path: '/marketing/index',
      name: 'marketingIndex',
      component: () => import('@/views/marketing/index.vue'),
      meta: { title: '营销作战图', subTitle: '全局统筹营销，落地 GEO 策略', key: 'marketing' },
    },
  ],
};
